// src/components/Home.js
import React from 'react';
import './Home.css'; // Create this CSS file for home specific styles

function Home() {
  return (
    <>
      <section className="hero">
        <h1>Premium Laundry & Ironing Services</h1>
        <p>Fast, affordable, and reliable service at your doorstep</p>
      </section>

      <section className="services" id="services">
        <div className="card">
          <h3>Ironing</h3>
          <p>Neatly pressed clothes with crisp finishes handled by professionals.</p>
        </div>
        <div className="card">
          <h3>Washing & Ironing</h3>
          <p>Complete garment care including wash and iron, ready to wear.</p>
        </div>
        <div className="card">
          <h3>Dry Cleaning</h3>
          <p>Perfect for your delicate, formal or designer wear with care and quality.</p>
        </div>
        <div className="card">
          <h3>Saree Rolling</h3>
          <p>Expert saree rolling for smooth folds and long-lasting structure.</p>
        </div>
      </section>

      <section className="about" id="about">
        <h2>About IronBhai</h2>
        <p>
          IronBhai was founded with one mission in mind - to make your laundry experience effortless.
          Whether it's a pile of office shirts, delicate sarees, or everyday wear, our dedicated team ensures
          every item is treated with the utmost care. We offer a blend of modern processes and traditional
          attention to detail that keeps your clothes looking their best.
        </p>
      </section>

      <section className="contact" id="contact">
        <h2>Contact Us</h2>
        <p>
          Have questions, suggestions, or need support? We're here to help!
        </p>
        <div style={{ textAlign: 'center' }}>
          <p><strong>Email:</strong> support@ironbhai.com</p>
          <p><strong>Phone:</strong> +91 8688206969</p>
          {/* <p><strong>Address:</strong> Flat No 201, Sai Datta Residency, Street No 4, Sector 2D, Puppalaguda, Manikonda, Hyderabad, India</p> */}
          <p><strong>Branches:</strong> Ameerpet | Manikonda | Kukatpally</p>
        </div>
      </section>
    </>
  );
}

export default Home;
